_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[24],{

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j36g");
module.exports = __webpack_require__("rB5V");


/***/ }),

/***/ "Juyh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_esm_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("h4VS");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nKUr");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("lTCR");
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(graphql_tag__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Styles_Title__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("1A3C");
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("vOnD");
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("g4pe");
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _components_Loading__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("VFWX");
/* harmony import */ var _components_Post_Content__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("h8PM");
/* harmony import */ var _apollo_react_hooks__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("ttZb");
/* harmony import */ var _lib_wordpress__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("xWpn");
/* harmony import */ var _components_Styles_Paragraph__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("rBKS");
/* harmony import */ var _util_markup__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("jZu3");




function _templateObject() {
  var data = Object(_babel_runtime_helpers_esm_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(["\n  query PRESS_CLIPPINGS_QUERY {\n    aboutText\n    abouts(first: 100) {\n      edges {\n        node {\n          featuredImage {\n            node {\n              id\n              uri\n              mediaDetails {\n                sizes {\n                  sourceUrl\n                  name\n                  width\n                  height\n                }\n              }\n            }\n          }\n          title\n          content(format: RAW)\n        }\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}











var HeaderIamge = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].img.withConfig({
  displayName: "about__HeaderIamge",
  componentId: "sc-1x273ln-0"
})(["width:100%;"]);
var Article = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].article.withConfig({
  displayName: "about__Article",
  componentId: "sc-1x273ln-1"
})(["padding-top:4rem;max-width:", ";margin:0 auto;"], function (props) {
  return props.theme.maxWidth;
});
var SnippetList = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({
  displayName: "about__SnippetList",
  componentId: "sc-1x273ln-2"
})(["h1{font-size:3rem;text-align:center;}grid-gap:20px;display:grid;align-items:center;grid-template-columns:1fr 1fr;max-width:", ";margin:0 auto;@media screen and (max-width:500px){grid-template-columns:1fr;}img,iframe{max-width:100%;}div.item{border-bottom:1px solid black;}"], function (props) {
  return props.theme.maxWidth;
});
var PRESS_CLIPPINGS_QUERY = graphql_tag__WEBPACK_IMPORTED_MODULE_2___default()(_templateObject());

var About = function About() {
  var _useQuery = Object(_apollo_react_hooks__WEBPACK_IMPORTED_MODULE_8__[/* useQuery */ "c"])(PRESS_CLIPPINGS_QUERY),
      data = _useQuery.data,
      error = _useQuery.error,
      loading = _useQuery.loading;

  if (loading) {
    return /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__["jsx"])(_components_Loading__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"], {});
  }

  if (error) {
    return /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__["jsx"])("div", {
      children: "error"
    });
  }

  return /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__["jsxs"])(Article, {
    children: [/*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__["jsxs"])(next_head__WEBPACK_IMPORTED_MODULE_5___default.a, {
      children: [/*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__["jsx"])("title", {
        children: "About"
      }), /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__["jsx"])("meta", {
        property: "og:locale",
        content: "de_DE"
      }), /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__["jsx"])("meta", {
        property: "og:type",
        content: "article"
      }), /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__["jsx"])("meta", {
        property: "og:site_name",
        content: "Modepilot"
      }), /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__["jsx"])("meta", {
        property: "article:author",
        content: "https://www.facebook.com/kathrin.bierling"
      }), /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__["jsx"])("meta", {
        property: "article:section",
        content: "Fashion"
      }), /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__["jsx"])("meta", {
        property: "fb:app_id",
        content: "861751020529444"
      })]
    }), /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__["jsx"])(HeaderIamge, {
      src: "https://www.modepilot.de/wp-content/uploads/2017/11/Modepilot-About-Kathrin-Bierling-Isabelle-Braun--1000x536.jpg"
    }), /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__["jsx"])(_components_Styles_Title__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"], {
      children: "About Modepilot"
    }), /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__["jsx"])(_components_Post_Content__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"], {
      content: data.aboutText
    }), /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__["jsx"])(_components_Styles_Title__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"], {
      children: "Presse"
    }), /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__["jsx"])(SnippetList, {
      children: data.abouts.edges.map(function (about) {
        var teaserImage = null;

        if (about.node.featuredImage) {
          teaserImage = Object(_lib_wordpress__WEBPACK_IMPORTED_MODULE_9__[/* getImageSize */ "c"])(about.node.featuredImage.node.mediaDetails.sizes, "home-layout-5");

          if (!teaserImage) {
            teaserImage = Object(_lib_wordpress__WEBPACK_IMPORTED_MODULE_9__[/* getImageSize */ "c"])(about.node.featuredImage.node.mediaDetails.sizes, "600x99999"); //console.log(about.node.featuredImage.mediaDetails.sizes);
          }
        }

        return /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__["jsxs"])("div", {
          className: "item",
          children: [teaserImage && /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__["jsx"])("img", {
            src: teaserImage.sourceUrl,
            alt: about.node.title
          }), /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__["jsx"])("h1", {
            children: about.node.title
          }), /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__["jsx"])(_components_Post_Content__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"], {
            content: about.node.content
          })]
        }, "snippet-".concat(about.id));
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (About);

/***/ }),

/***/ "rB5V":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about",
      function () {
        return __webpack_require__("Juyh");
      }
    ]);
  

/***/ })

},[[9,0,1,2,3,4,5,7,6,8,10,9,12,14]]]);